/**
 * 에이전트 서비스
 */

import apiClient from './api';
import {
  Agent,
  AgentFilter,
  AgentListResponse,
  AgentSalesStats,
  AgentSettlement,
} from '../types/agent';

export const agentService = {
  /**
   * 에이전트 목록 조회
   */
  async getAgents(filter: AgentFilter = {}): Promise<AgentListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: AgentListResponse }>(`/admin/agents?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      agents: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 에이전트 상세 조회
   */
  async getAgent(id: number): Promise<Agent> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { agent: Agent } }>(`/admin/agents/${id}`);
    // return response.data.data.agent;

    throw new Error('Not implemented');
  },

  /**
   * 에이전트 등록
   */
  async createAgent(data: Partial<Agent>): Promise<Agent> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { agent: Agent } }>('/admin/agents', data);
    // return response.data.data.agent;

    throw new Error('Not implemented');
  },

  /**
   * 에이전트 수정
   */
  async updateAgent(id: number, data: Partial<Agent>): Promise<Agent> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { agent: Agent } }>(`/admin/agents/${id}`, data);
    // return response.data.data.agent;

    throw new Error('Not implemented');
  },

  /**
   * 에이전트 삭제
   */
  async deleteAgent(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/agents/${id}`);

    throw new Error('Not implemented');
  },

  /**
   * 에이전트 판매 통계 조회
   */
  async getAgentSalesStats(
    agentId: number,
    periodStart: string,
    periodEnd: string
  ): Promise<AgentSalesStats> {
    // TODO: 백엔드 API 구현 후 연동
    // const params = new URLSearchParams();
    // params.append('period_start', periodStart);
    // params.append('period_end', periodEnd);
    // const response = await apiClient.get<{ data: { stats: AgentSalesStats } }>(`/admin/agents/${agentId}/sales-stats?${params.toString()}`);
    // return response.data.data.stats;

    throw new Error('Not implemented');
  },

  /**
   * 에이전트 정산 목록 조회
   */
  async getAgentSettlements(agentId: number): Promise<AgentSettlement[]> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { settlements: AgentSettlement[] } }>(`/admin/agents/${agentId}/settlements`);
    // return response.data.data.settlements;

    return [];
  },
};

